import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import translationEN from "./locales/en/translation.json";
import translationZH_CN from "./locales/zh-cn/translation.json";
import translationZH_HK from "./locales/zh-hk/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  zh_cn: {
    translation: translationZH_CN,
  },
  zh_hk: {
    translation: translationZH_HK,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") ?? "en", // Default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
